import { useContext } from "react";
import { useParams } from "react-router-dom";

import { DatasetEditorContext } from "@/components/DatasetEditor";
import { DownloadIconWithProgress, getExportLabel } from "@/components/ui/DownloadWithProgress";
import { useExportDatasetToCsv } from "@/queries/datasets";

export const useDownloadDataset = () => {
  const { datasetId } = useParams<{
    datasetId: string;
  }>();
  const context = useContext(DatasetEditorContext);
  const { mutate: exportDatasetToCsv, isPending: isMutating } = useExportDatasetToCsv();

  const isExporting = context?.processingType === "export";
  const progress = isExporting ? (context?.processingProgress ?? 0) : null;

  const handleDownload = () => {
    context?.setProcessingType?.("export");
    exportDatasetToCsv(Number(datasetId));
  };

  const DownloadIcon = () => (
    <DownloadIconWithProgress progress={progress} progressClassName="bg-gray-100" />
  );

  return {
    id: "download-dataset",
    label: getExportLabel(progress, "Download"),
    icon: DownloadIcon,
    getDisabled: () => context?.isRowsEmpty || isExporting,
    onClick: handleDownload,
    shouldShow: !!context?.rows?.length,
    isLoading: isMutating || isExporting,
  };
};
